export const EMPLOYMENT_TYPE = {
  FINANCIAL_SERVICE: 1,
  SELF_EMPLOYED: 2,
};
